import { render, staticRenderFns } from "./CurrentlyLooking.vue?vue&type=template&id=a0a6f516"
import script from "./CurrentlyLooking.vue?vue&type=script&lang=js"
export * from "./CurrentlyLooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports